module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "options": _vm.listaBancos,
      "multiple": false,
      "close-on-select": true,
      "placeholder": "Selecione um banco",
      "custom-label": _vm.bancoNome,
      "track-by": "codigo",
      "selectedLabel": "Selecionado",
      "selectLabel": "Aperte ENTER para selecionar",
      "deselectLabel": "Aperte ENTER para remover",
      "name": "banco",
      "data-vv-as": "banco",
      "disabled": _vm.$attrs.disabled
    },
    on: {
      "select": _vm.selecionaBanco
    },
    model: {
      value: (_vm.bancoSelecionado),
      callback: function($$v) {
        _vm.bancoSelecionado = $$v
      },
      expression: "bancoSelecionado"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('banco')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('banco')))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b76f53b6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/solicitacoes/adiantamento/componentes/listaBancos.vue
// module id = 2062
// module chunks = 1